<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ReportHeader from './components/ReportHeader.vue';
import ConversationHeatmapContainer from './components/heatmaps/ConversationHeatmapContainer.vue';
import WonSalesChartContainer from './components/heatmaps/WonSalesChartContainer.vue';
import AgentLiveReportContainer from './components/AgentLiveReportContainer.vue';
import StatsLiveReportsContainer from './components/StatsLiveReportsContainer.vue';
import {
  isLiveRefreshEnabled,
  toggleLiveRefresh,
} from 'dashboard/composables/useLiveRefresh';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const refreshKey = ref(0);

const handleManualRefresh = () => {
  refreshKey.value += 1;
};
</script>

<template>
  <ReportHeader :header-title="$t('OVERVIEW_REPORTS.HEADER')">
    <div class="flex items-center gap-2">
      <!-- Botón de actualización manual -->
      <Button
        type="button"
        variant="outline"
        size="sm"
        icon="i-lucide-refresh-cw"
        :title="t('OVERVIEW_REPORTS.REFRESH_NOW')"
        @click="handleManualRefresh"
      />

      <!-- Switch/Toggle En Vivo -->
      <button
        type="button"
        class="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border text-xs font-semibold transition-all cursor-pointer shadow-2xs focus:outline-hidden"
        :class="
          isLiveRefreshEnabled
            ? 'bg-n-teal-3 border-n-teal-6 text-n-teal-11 hover:bg-n-teal-4'
            : 'bg-n-solid-2 border-n-container text-n-slate-11 hover:bg-n-solid-3'
        "
        :title="
          isLiveRefreshEnabled
            ? t('OVERVIEW_REPORTS.PAUSE_LIVE_TOOLTIP')
            : t('OVERVIEW_REPORTS.RESUME_LIVE_TOOLTIP')
        "
        @click="toggleLiveRefresh()"
      >
        <span
          class="h-2 w-2 rounded-full transition-colors"
          :class="
            isLiveRefreshEnabled ? 'bg-n-teal-9 animate-pulse' : 'bg-n-slate-8'
          "
        />
        <span>
          {{
            isLiveRefreshEnabled
              ? t('OVERVIEW_REPORTS.LIVE_ENABLED')
              : t('OVERVIEW_REPORTS.LIVE_PAUSED')
          }}
        </span>
        <span
          class="size-3.5"
          :class="isLiveRefreshEnabled ? 'i-lucide-pause' : 'i-lucide-play'"
        />
      </button>
    </div>
  </ReportHeader>
  <div :key="refreshKey" class="flex flex-col gap-4 pb-6">
    <StatsLiveReportsContainer />
    <ConversationHeatmapContainer />
    <WonSalesChartContainer />
    <AgentLiveReportContainer />
  </div>
</template>

